import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { memo } from 'react'
import { TRANSITION_CUBIC, TRANSITION_SIMPLE } from 'styles'

import { makeStyles } from '@mui/styles'

import icons from './icons'

const useStyles = makeStyles({
  '@global': {
    ...icons,
    body: {
      fontFamily: '"Open Sans", -apple-system, sans-serif',
      margin: '0',
      padding: '0',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
    },
    ul: {
      listStyle: 'none',
    },
    '.cursor-pointer': {
      cursor: 'pointer',
      userSelect: 'none',
      '-webkit-tap-highlight-color': 'transparent',
    },
    '.rotatable': {
      transition: `transform 150ms ${TRANSITION_CUBIC}`,
    },
    '.rotate': {
      transform: 'rotate(180deg)',
    },

    // Used for react-responsive-carousel with ChannelsSummary
    '.carousel-wrapper > div > .carousel .slide': {
      textAlign: 'inherit',
      background: 'none !important',
      display: 'flex',
      justifyContent: 'flex-start',
    },
    '.carousel-wrapper > div > .carousel ul.control-dots:not(.show)': {
      display: 'none',
      position: 'absolute',
      width: 'initial',
      margin: '0',
      top: '1rem',
      bottom: 'initial',
      right: '2rem',
    },
    '.carousel-wrapper > div > .carousel .control-dots .dot': {
      margin: '0 0.2rem',
    },
    '.carousel-wrapper > div > .carousel ul.control-dots li.dot': {
      background: '#eaedf0',
      boxShadow: 'none',
      opacity: 1,
      transition: TRANSITION_SIMPLE,
    },
    '.carousel-wrapper > div > .carousel ul.control-dots li.dot.selected': {
      background: '#12233a',
    },
  },
})

function GlobalStyles() {
  useStyles()

  return null
}

export default memo(GlobalStyles)
